import { kea } from 'kea'
import PropTypes from 'prop-types'
import { put } from 'redux-saga/effects'

export default kea({
  path: () => ['scenes', 'webcamPhoto', 'index'],

  actions: () => ({
    activeWebcam: stream => ({ stream }),
    setError: error => ({ error }),
    initStream: true,
    activeStreaming: true,
    setUiSize: (width, height) => ({ width, height }),
    setInputSize: (width, height) => ({ width, height }),
    setCropSize: cropSize => ({ cropSize }),
    setPreviewImage: previewImage => ({ previewImage }),
    setOriginInputSize: (width, height) => ({ width, height }),
    setLargeImage: largeImage => ({ largeImage }),
    adjustView: true,
    takePicture: true,
    pauseWebcam: true,
    startWebcam: true,
    uploadPicture: uploadFunction => ({ uploadFunction }),
    setCounterValue: value => ({ value }),
    resetCam: true,
    initUserMedia: true,
    disableWebCam: true,
    initUI: true,
    setOrientation: orientation => ({ orientation }),
    blockActions: true,
    enableActions: true
  }),

  reducers: ({ actions }) => ({
    isActionsActive: [
      false,
      PropTypes.book,
      {
        [actions.enableActions]: () => true,
        [actions.blockActions]: () => false
      }
    ],
    orientation: [
      '',
      PropTypes.string,
      {
        [actions.setOrientation]: (_, { orientation }) => orientation,
        [actions.resetCam]: () => ''
      }
    ],
    cropSize: [
      720,
      PropTypes.number,
      {
        [actions.setCropSize]: (_, { cropSize }) => cropSize,
        [actions.resetCam]: () => 720
      }
    ],
    previewImage: [
      '',
      PropTypes.string,
      {
        [actions.setPreviewImage]: (_, { previewImage }) => previewImage,
        [actions.resetCam]: () => ''
      }
    ],
    largeImage: [
      '',
      PropTypes.string,
      {
        [actions.setLargeImage]: (_, { largeImage }) => largeImage,
        [actions.resetCam]: () => ''
      }
    ],
    error: [
      '',
      PropTypes.string,
      {
        [actions.setError]: (_, { error }) => error,
        [actions.resetCam]: () => ''
      }
    ],
    uiWidth: [
      0,
      PropTypes.number,
      {
        [actions.setUiSize]: (_, { width }) => width,
        [actions.resetCam]: state => state
      }
    ],
    uiHeight: [
      0,
      PropTypes.number,
      {
        [actions.setUiSize]: (_, { height }) => height
      }
    ],
    inputWidth: [
      0,
      PropTypes.number,
      {
        [actions.setInputSize]: (_, { width }) => width
      }
    ],
    inputHeight: [
      0,
      PropTypes.number,
      {
        [actions.setInputSize]: (_, { height }) => height
      }
    ],
    originalInputWidth: [
      0,
      PropTypes.number,
      {
        [actions.setOriginInputSize]: (_, { width }) => width,
        [actions.resetCam]: () => 0
      }
    ],
    originalInputHeight: [
      0,
      PropTypes.number,
      {
        [actions.setOriginInputSize]: (_, { height }) => height,
        [actions.resetCam]: () => 0
      }
    ],
    isCamReady: [
      false,
      PropTypes.bool,
      {
        [actions.activeWebcam]: _ => true,
        [actions.resetCam]: () => false
      }
    ],
    stream: [
      null,
      PropTypes.object,
      {
        [actions.activeWebcam]: (state, { stream }) => stream || state,
        [actions.disableWebCam]: () => null
      }
    ],
    streaming: [
      false,
      PropTypes.bool,
      {
        [actions.activeStreaming]: () => true,
        [actions.resetCam]: () => false
      }
    ],
    counterValue: [
      0,
      PropTypes.number,
      {
        [actions.setCounterValue]: (_, { value }) => value,
        [actions.resetCam]: () => 0
      }
    ]
  }),

  takeLatest: ({ actions }) => ({
    [actions.resetCam]: function * () {
      const { disableWebCam } = this.actions
      const stream = yield this.get('stream')
      if (stream) {
        const videoTracks = stream.getVideoTracks()
        videoTracks[0].stop()
        yield put(disableWebCam())
      }
    }
  })
})
